module.exports = ".red-border-class{\n  border: 1px solid red !important;\n}\n\n.note_exc{\n  text-align: right !important;\n}"